import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import { getToken } from 'services/auth';
import { Navigate, useParams } from 'react-router';
import MinimalLayout from 'layout/MinimalLayout';

// dashboard routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const Forgot3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Forgot3')));
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

const Loja = Loadable(lazy(() => import('views/pages/loja')));
const LojaForm = Loadable(lazy(() => import('views/pages/loja/form')));

const PerfilAcesso = Loadable(lazy(() => import('views/pages/perfil-acesso')));
const PerfilAcessoForm = Loadable(lazy(() => import('views/pages/perfil-acesso/form')));

const Cargo = Loadable(lazy(() => import('views/pages/cargo')));
const CargoForm = Loadable(lazy(() => import('views/pages/cargo/form')));

const Company = Loadable(lazy(() => import('views/pages/company')));
const CompanyForm = Loadable(lazy(() => import('views/pages/company/form')));

const UsuarioApi = Loadable(lazy(() => import('views/pages/usuario-api')));
const UsuarioApiForm = Loadable(lazy(() => import('views/pages/usuario-api/form')));

const Usuario = Loadable(lazy(() => import('views/pages/usuario')));
const UsuarioForm = Loadable(lazy(() => import('views/pages/usuario/form')));

const UsuarioEmpresa = Loadable(lazy(() => import('views/pages/usuario-empresa')));
const UsuarioEmpresaForm = Loadable(lazy(() => import('views/pages/usuario-empresa/form')));

const TransacaoSistema = Loadable(lazy(() => import('views/pages/transacao-sistema')));
const TransacaoSistemaForm = Loadable(lazy(() => import('views/pages/transacao-sistema/form')));

const SmsProvider = Loadable(lazy(() => import('views/pages/sms-provider')));
const SmsProviderForm = Loadable(lazy(() => import('views/pages/sms-provider/form')));

const CatalogLink = Loadable(lazy(() => import('views/pages/catalog-link')));
const CatalogLinkForm = Loadable(lazy(() => import('views/pages/catalog-link/form')));

const ConteudoCadastroPromo = Loadable(lazy(() => import('views/pages/conteudo-cadastro-promo')));
const ConteudoCadastroPromoForm = Loadable(lazy(() => import('views/pages/conteudo-cadastro-promo/form')));

const TiposPromocao = Loadable(lazy(() => import('views/pages/tipos-promocao')));
const TiposPromocaoForm = Loadable(lazy(() => import('views/pages/tipos-promocao/form')));

const PromocoesMarketplace = Loadable(lazy(() => import('views/pages/promocoes-marketplace')));
const PromocoesMarketplaceEmpresa = Loadable(lazy(() => import('views/pages/promocoes-marketplace/empresa')));

function TipoPromocaoCamposLegacyRedirect() {
    const { tipoPromocaoId } = useParams();
    return <Navigate to={`/tipos-promocao/form/${tipoPromocaoId}`} replace />;
}

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = (isLoggedIn) => [
    {
        path: '/',
        element: isLoggedIn ? <MainLayout /> : <Navigate to="/login" />,
        children: [
            {
                path: '/',
                element: <DashboardDefault />
            },
            {
                path: '/dashboard/default',
                element: <DashboardDefault />
            },
            {
                path: '/utils/util-typography',
                element: <UtilsTypography />
            },
            {
                path: '/utils/util-color',
                element: <UtilsColor />
            },
            {
                path: '/utils/util-shadow',
                element: <UtilsShadow />
            },
            {
                path: '/icons/tabler-icons',
                element: <UtilsTablerIcons />
            },
            {
                path: '/icons/material-icons',
                element: <UtilsMaterialIcons />
            },
            {
                path: '/loja',
                element: <Loja />
            },
            {
                path: '/loja/form/:catalogName/:dbName/:id',
                element: <LojaForm />
            },
            {
                path: '/perfil-acesso',
                element: <PerfilAcesso />
            },
            {
                path: '/perfil-acesso/form',
                element: <PerfilAcessoForm />
            },
            {
                path: '/perfil-acesso/form/:id',
                element: <PerfilAcessoForm />
            },
            {
                path: '/cargo',
                element: <Cargo />
            },
            {
                path: '/cargo/form',
                element: <CargoForm />
            },
            {
                path: '/cargo/form/:id',
                element: <CargoForm />
            },
            {
                path: '/empresa',
                element: <Company />
            },
            {
                path: '/empresa/form',
                element: <CompanyForm />
            },
            {
                path: '/empresa/form/:id',
                element: <CompanyForm />
            },
            {
                path: '/usuario-api',
                element: <UsuarioApi />
            },
            {
                path: '/usuario-api/form',
                element: <UsuarioApiForm />
            },
            {
                path: '/usuario-api/form/:id',
                element: <UsuarioApiForm />
            },
            {
                path: '/usuario',
                element: <Usuario />
            },
            {
                path: '/usuario/form',
                element: <UsuarioForm />
            },
            {
                path: '/usuario/form/:id',
                element: <UsuarioForm />
            },
            {
                path: '/usuario-empresa',
                element: <UsuarioEmpresa />
            },
            {
                path: '/usuario-empresa/form',
                element: <UsuarioEmpresaForm />
            },
            {
                path: '/usuario-empresa/form/:id',
                element: <UsuarioEmpresaForm />
            },
            {
                path: '/transacao-sistema',
                element: <TransacaoSistema />
            },
            {
                path: '/transacao-sistema/form/:id',
                element: <TransacaoSistemaForm />
            },
            {
                path: '/sms-provider',
                element: <SmsProvider />
            },
            {
                path: '/sms-provider/form/:catalogName/:dbName/:id',
                element: <SmsProviderForm />
            },
            {
                path: '/catalog-link',
                element: <CatalogLink />
            },
            {
                path: '/catalog-link/form/:id',
                element: <CatalogLinkForm />
            },
            {
                path: '/conteudo-cadastro-promo',
                element: <ConteudoCadastroPromo />
            },
            {
                path: '/conteudo-cadastro-promo/form',
                element: <ConteudoCadastroPromoForm />
            },
            {
                path: '/conteudo-cadastro-promo/form/:id',
                element: <ConteudoCadastroPromoForm />
            },
            {
                path: '/tipos-promocao',
                element: <TiposPromocao />
            },
            {
                path: '/tipos-promocao/form',
                element: <TiposPromocaoForm />
            },
            {
                path: '/tipos-promocao/form/:id',
                element: <TiposPromocaoForm />
            },
            {
                path: '/tipo-promocao-campos',
                element: <Navigate to="/tipos-promocao" replace />
            },
            {
                path: '/tipo-promocao-campos/form/:tipoPromocaoId',
                element: <TipoPromocaoCamposLegacyRedirect />
            },
            {
                path: '/promocoes-marketplace',
                element: <PromocoesMarketplace />
            },
            {
                path: '/promocoes-marketplace/:tipoPromocaoId',
                element: <PromocoesMarketplaceEmpresa />
            }
        ]
    },
    {
        path: '/',
        element: !isLoggedIn ? <MinimalLayout /> : <Navigate to="/dashboard/default" />,
        children: [
          { path: 'login', element: <AuthLogin3 /> },
          { path: 'forgot', element: <Forgot3 /> }
        ]
      }
];

export default MainRoutes;